module.exports = __webpack_public_path__ + "static/media/migrate.54dde500.svg";